var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomModel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_694_11507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.25537 1.18403C9.73454 1.00232 10.2661 1.00232 10.7453 1.18403L18.2323 4.02403C19.0446 4.33286 19.5837 5.11226 19.5837 5.98449V15.1111C19.5837 15.9834 19.0446 16.762 18.2323 17.0727L10.7453 19.9103C10.2661 20.06 9.73454 20.06 9.25537 19.9103L1.76989 17.0727C0.95568 16.762 0.416992 15.9834 0.416992 15.1111V5.98449C0.416992 5.11226 0.95568 4.33286 1.76989 4.02403L9.25537 1.18403ZM10.1051 2.86392C10.0378 2.83809 9.9292 2.83809 9.89551 2.86392L2.7986 5.55399L10.0003 8.38407L17.2028 5.55399L10.1051 2.86392ZM2.40703 15.3919L9.10189 17.93V9.96382L2.21387 7.25728V15.1111C2.21387 15.2347 2.29098 15.347 2.40703 15.3919ZM10.8988 17.93L17.5921 15.3919C17.7082 15.347 17.7868 15.2347 17.7868 15.1111V7.25728L10.8988 9.96382V17.93Z",
    fill: "#595959"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_694_11507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.1667,
    height: 19.1667,
    fill: "white",
    transform: "translate(0.416992 0.951828)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomModel);
export default __webpack_public_path__ + "static/media/custom-model.b723aebc321ac41ca89392932214ffac.svg";
export { ForwardRef as ReactComponent };